/* JAILBIRD BOOKS - 手数料だけがカートに残らないようにする（全ページ共通。layout/theme.liquid で読み込み）

   カートドロワー・カートページのどちらで削除・数量0にしても、テーマは document に 'on:cart:change' を投げる
   （assets/main.js の cart-form）。そのたびにカートを確認し、次のルールで手数料を自動で削除する。

   1. system-fee タグの商品（差し入れ代行費・匿名配送費・JAILBIRD DAWGS 差し入れ代行 など）以外の商品が
      カートに1つもなければ、system-fee の商品をすべて削除する。
      ただし「JAILBIRD DAWGS ドネーション」は system-fee タグが付いていても、それ自体が購入品なので削除しない
      （ほかの商品があるかどうかの判定にも数えない）。
   2. 「JAILBIRD DAWGS 差し入れ代行」は、DAWGS の3冊セットがカートになければ、ほかの商品が残っていても削除する。
   3. 削除してカートが空になったら、注文種別などのカート属性も空に戻す（jb-cart-ordertype.js と同じ項目）。

   タグは /cart.js に含まれないため、/products/{handle}.js で取得する（同じページ内ではキャッシュ）。
   カートページ（/cart）では空表示がサーバー側描画のため、削除後に再読み込みする。
   それ以外のページでは 'on:cart:change' を投げてカートドロワーを描き直す。
   jb-cart-ordertype.js の jbCleanupFeeOnlyCart() もこの処理（window.JBFeeCleanup.run）を使う。 */
(function () {
  var FEE_TAG = 'system-fee';
  var KEEP_HANDLES = ['jailbird-dawgs-donation']; // system-fee でも自動削除しない（それ自体が購入品）
  var DAWGS_SET_VARIANT = 62698114023795; // JAILBIRD DAWGS 3冊セット（送料込）
  var DAWGS_PROXY_PRODUCT = 15334994411891; // JAILBIRD DAWGS 差し入れ代行
  var tagCache = {};
  var running = false;
  var timer = null;

  function getTags(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) { tagCache[handle] = p.tags || []; return tagCache[handle]; })
      .catch(function () { return []; }); // 取得できないときは通常の商品として扱う（誤って消さない）
  }

  async function run() {
    if (running) return false;
    running = true;
    try {
      var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
      if (!cart.items.length) return false;

      var info = await Promise.all(cart.items.map(function (i) {
        return getTags(i.handle).then(function (tags) {
          var isFee = tags.indexOf(FEE_TAG) !== -1 && KEEP_HANDLES.indexOf(i.handle) === -1;
          var isKept = KEEP_HANDLES.indexOf(i.handle) !== -1;
          return { item: i, isFee: isFee, isReal: !isFee && !isKept };
        });
      }));

      var hasReal = info.some(function (x) { return x.isReal; });
      var hasDawgsSet = cart.items.some(function (i) { return i.variant_id === DAWGS_SET_VARIANT; });
      var updates = {};
      info.forEach(function (x) {
        if (!x.isFee) return;
        if (!hasReal) updates[x.item.key] = 0;
        else if (x.item.product_id === DAWGS_PROXY_PRODUCT && !hasDawgsSet) updates[x.item.key] = 0;
      });
      var keys = Object.keys(updates);
      if (!keys.length) return false;

      var body = { updates: updates };
      if (keys.length === cart.items.length) {
        // カートが空になる → 注文種別などの属性も空に戻す
        body.attributes = { order_type: '', delivery_option: '', message_text: '', wants_stationery: '', anon_type: '', sender_name: '' };
      }
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      });

      if (/^\/cart\/?$/.test(location.pathname)) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      }
      return true;
    } catch (e) {
      return false;
    } finally {
      running = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 300);
  }

  window.JBFeeCleanup = { run: run };
  document.addEventListener('on:cart:change', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
